import { useTranslation } from 'react-i18next';
import { SectionPanel } from '~/components/ui/SectionPanel';
import {
  LocationAndVehicleSelects,
  type PickableBuyListLocation,
} from '~/pages/buy-lists/sections/LocationAndVehicleSelects';
import {
  SummaryProductsPanel,
  type SummaryProduct,
} from '~/pages/buy-lists/sections/SummaryProductsPanel';
import type { SelectedSellerFacility } from '~/components/common/SelectSellerFacilityStep';

type AddBuyListToCartSummaryStepProps = {
  products: SummaryProduct[];
  selectedFacility: SelectedSellerFacility;
  locations: PickableBuyListLocation[];
  locationId: string | null;
  transportVehicleId: string | null;
  onLocationChange: (locationId: string) => void;
  onTransportVehicleChange: (transportVehicleId: string) => void;
};

export function AddBuyListToCartSummaryStep({
  products,
  selectedFacility,
  locations,
  locationId,
  transportVehicleId,
  onLocationChange,
  onTransportVehicleChange,
}: Readonly<AddBuyListToCartSummaryStepProps>) {
  const { t } = useTranslation('inventory');

  return (
    <div className="flex flex-col gap-4" data-testid="add-to-cart-summary">
      <SectionPanel title={t('inventory.buy_list.add_to_cart.summary_seller')}>
        <p
          className="flex flex-col gap-0.5"
          data-testid="add-to-cart-summary-seller"
        >
          <span className="text-sm font-semibold text-neut-prim">
            {selectedFacility.organizationLabel}
          </span>
          <span className="text-xs text-neut-sec">
            {selectedFacility.facilityLabel}
          </span>
        </p>
      </SectionPanel>

      <SectionPanel
        title={t('inventory.buy_list.add_to_cart.summary_ship_to_location')}
        bodyClassName="space-y-3 p-4"
      >
        <LocationAndVehicleSelects
          locations={locations}
          locationId={locationId}
          transportVehicleId={transportVehicleId}
          onLocationChange={onLocationChange}
          onTransportVehicleChange={onTransportVehicleChange}
          locationTestId="add-to-cart-location-select"
          vehicleTestId="add-to-cart-vehicle-select"
        />
      </SectionPanel>

      <SummaryProductsPanel
        title={t('inventory.buy_list.add_to_cart.summary_products')}
        products={products}
        testIdPrefix="add-to-cart-summary"
      />
    </div>
  );
}
